<template>
    <BaseButton
        :style="{ backgroundColor: `${provider.hex_code}` }"
        class="shadow flex justify-center py-2 px-4 mb-4"
    >
        <img :src="provider.icon_url" :alt="provider.name" class="h-12">
    </BaseButton>
</template>

<script>
import BaseButton from '@/components/Base/BaseButton.vue'

export default {
    components: {
        BaseButton,
    },
    props: {
        provider: {
            type: Object,
            required: true,
        },
    },
}
</script>
